import React from 'react';
import BrandTierHeader from '../BrandTierHeader';
import BrandTierList from '../BrandTierList';
import BrandTierSelectorSection from '../BrandTierSelectorSection';
import './BrandTierWrap.scss';

const BrandTierWrap = (props) => {
  const {
    // 데이터
    currentTierList,
    brandTierHeader,
    brandTierList,
    brandTierSelector,
    // reducer의 데이터 수정
    setData,
    // 헤더에서 쓰이는 메소드들
    multipleTierChange,
    checkIsModified,
    editBrandTierListRequest,
    resetBrandTierInfo,
    // 리스트에서 쓰이는 메소드들
    scrollToBrandElement,
    selectBrandTierItem,
    selectBrandTierList,
    deselectBrandTierItem,
    changeTierOnBrandTierList,
    changeNumberOnDragEnd,
    changeNumberOnBrandTierList,
    deleteBrandTier,
    // 셀렉터에서 쓰이는 메소드들
    searchBrandTierSelectorList,
    resetBrandTierSelectorList,
    addBrandTierListItem,
    checkIsDuplicateOnTierList,
    selectSelectorList,
    checkIsSelectedOnSelector,
    addSelectedItemToList,
  } = props;

  return (
    <div className="brand-tier-section">
      {/*브랜드 티어 헤더*/}
      <BrandTierHeader
        currentTierList={currentTierList}
        brandTierHeader={brandTierHeader}
        brandTierList={brandTierList}
        setData={setData}
        multipleTierChange={multipleTierChange}
        checkIsModified={checkIsModified}
        editBrandTierListRequest={editBrandTierListRequest}
        resetBrandTierInfo={resetBrandTierInfo}
      />

      <div className="brand-tier-content">
        {/*브랜드 티어 리스트*/}
        <BrandTierList
          brandTierList={{
            currentTierList,
            newList: brandTierList.newList,
            selectedList: brandTierList.selectedList,
            toggleList: brandTierList.toggleList,
          }}
          setData={setData}
          selectBrandTierItem={selectBrandTierItem}
          selectBrandTierList={selectBrandTierList}
          deselectBrandTierItem={deselectBrandTierItem}
          changeTierOnBrandTierList={changeTierOnBrandTierList}
          changeNumberOnDragEnd={changeNumberOnDragEnd}
          changeNumberOnBrandTierList={changeNumberOnBrandTierList}
          scrollToBrandElement={scrollToBrandElement}
          deleteBrandTier={deleteBrandTier}
        />

        {/*브랜드 셀렉터*/}
        <BrandTierSelectorSection
          currentTierList={currentTierList}
          brandTierSelector={brandTierSelector}
          setData={setData}
          searchBrandTierSelectorList={searchBrandTierSelectorList}
          resetBrandTierSelectorList={resetBrandTierSelectorList}
          addBrandTierListItem={addBrandTierListItem}
          checkIsDuplicateOnTierList={checkIsDuplicateOnTierList}
          selectSelectorList={selectSelectorList}
          checkIsSelectedOnSelector={checkIsSelectedOnSelector}
          addSelectedItemToList={addSelectedItemToList}
        />
      </div>
    </div>
  );
};

export default BrandTierWrap;
